module.exports = window["ReactDOMClient"];